module.exports = __webpack_public_path__ + "img/minor-prize.9097ca72.png";